import React, { useState, useEffect, useRef } from "react";
import './section1.css';
import bannerImg from '../../assets/banners/Cabecalho.svg';
import headerMobileImg from '../../assets/mobile/headerMobile.svg';
import CardSection1 from './cardSection1'; // IMPORTAÇÃO DO CARD

const Section1 = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showHotelCard, setShowHotelCard] = useState(false);
  const [showExpositorMenu, setShowExpositorMenu] = useState(false); // NOVO

  const menuRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideMenu = menuRef.current && !menuRef.current.contains(event.target);
      const clickedOutsideMobileMenu = mobileMenuRef.current && !mobileMenuRef.current.contains(event.target);
      const clickedOutsideButton = buttonRef.current && !buttonRef.current.contains(event.target);

      if (isMenuOpen && clickedOutsideMenu && clickedOutsideMobileMenu && clickedOutsideButton) {
        setIsMenuOpen(false);
      }

      // Fecha submenu do expositor ao clicar fora
      if (showExpositorMenu && menuRef.current && !menuRef.current.contains(event.target)) {
        setShowExpositorMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMenuOpen, showExpositorMenu]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }, [isMenuOpen]);

  return (
    <header className="header">
      <img src={bannerImg} alt="Banner" className="header-img desktop-header-img" />
      <img src={headerMobileImg} alt="Banner Mobile" className="header-img mobile-header-img" />

      {/* NAV DESKTOP */}
      <nav className="nav-links" ref={menuRef}>
        <a href="https://solar.totaldrogaria.com.br/login" target="_blank" rel="noopener noreferrer">Área do Associado</a>
        <a href="#link2">Programação</a>
        <a href="#link3">Como Chegar</a>
        <a href="#link8">Parceiros</a>
        

        {/* BOTÃO COM SUBMENU */}
        <div className="participar-wrapper" onMouseLeave={() => setShowExpositorMenu(false)}>
          <button className="link-button" onClick={() => setShowExpositorMenu(!showExpositorMenu)}>
            Área do Expositor
          </button>
          {showExpositorMenu && (
            <div className="participar-menu">
              <a href="https://www.i-techhouse.com.br/ManualExpositorV2/login.aspx?ReturnUrl=%2fManualExpositorV2%2fdefault.aspx%3fkeycode%3d6B941863-B0D5-4AD9-B09B-41DAC095C951%26lang%3dP&keycode=6B941863-B0D5-4AD9-B09B-41DAC095C951&lang=P" target="_blank" rel="noopener noreferrer">Se Inscreva Aqui</a>

              
     <button
  className="submenu-link"
  onClick={() => setShowHotelCard(true)}
>
  Hotéis
</button>


              
            </div>
          )}
        </div>

        <a href="https://euvou.events/42feiradenegocios2025@associadoscessionariosefranqueado" target="_blank" rel="noopener noreferrer" className="button-link">Quero Participar!</a>
      </nav>

      {/* HEADER MOBILE */}
      <div className="mobile-header-extras">
        <a href="https://euvou.events/42feiradenegocios2025@associadoscessionariosefranqueado" target="_blank" rel="noopener noreferrer" className="mobile-button-link">Quero Participar!</a>
        <button
          ref={buttonRef}
          className={`hamburger-btn ${isMenuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {isMenuOpen && <div className="menu-overlay"></div>}

      {/* MENU MOBILE */}
      <nav ref={mobileMenuRef} className={`nav-links-mobile ${isMenuOpen ? 'active' : ''}`}>
        <a href="https://solar.totaldrogaria.com.br/login" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>Área do Associado</a>
        <a href="#link2" onClick={() => setIsMenuOpen(false)}>Programação</a>
        <a href="#link3" onClick={() => setIsMenuOpen(false)}>Como Chegar</a>
        <a href="#link8" onClick={() => setIsMenuOpen(false)}>Parceiros</a>
        <div className="mobile-expositor-title">Área do Expositor</div>

        <button className="link-button" onClick={() => {
          setShowHotelCard(true);
          setIsMenuOpen(false);
        }}>
          Hotéis
        </button>
         <a href="https://www.i-techhouse.com.br/ManualExpositorV2/login.aspx?ReturnUrl=%2fManualExpositorV2%2fdefault.aspx%3fkeycode%3d6B941863-B0D5-4AD9-B09B-41DAC095C951%26lang%3dP&keycode=6B941863-B0D5-4AD9-B09B-41DAC095C951&lang=P" target="_blank" rel="noopener noreferrer">Se Inscreva Aqui</a>
        {/* MANTIDO COMO LINK NO MOBILE */}
        
      </nav>

      {showHotelCard && <CardSection1 onClose={() => setShowHotelCard(false)} />}
    </header>
  );
};

export default Section1;
